import { type StyledOptions } from '@emotion/styled';

/**
 * @function removeTheseProps This util function is used for 'shouldForward' function for styled components.
 */

export const removeTheseProps =
  <ComponentProps>(
    ...propsToRemove: Array<keyof ComponentProps>
  ): StyledOptions['shouldForwardProp'] =>
  (propName: PropertyKey) => {
    return !new Set(propsToRemove).has(propName as keyof ComponentProps);
  };
